import axios from 'axios';
import { getApiBaseUrl } from '@api/config/baseUrlConfig';
import { requestInterceptor } from '@api/interceptors/requestInterceptor';
import { errorInterceptor, responseInterceptor } from '@api/interceptors/responseInterceptor';


const fetch = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    common: {
      'Content-Type': 'application/json'
    }
  },
  transformResponse: [(res) => res]
});

fetch.interceptors.request.use(requestInterceptor);
fetch.interceptors.response.use(responseInterceptor, errorInterceptor);

export default fetch;
